//@flow
import * as actionTypes from './actionTypes';
import {
    submitTaskApi,getHermesTaskApi,getHermesVendorsApi
} from '../../apiUtils/api';
import type { Dispatch,ReducerState$Type,PostPayloadData } from './flowTypes'
import { transformDataToEditFormData } from './editFormData'
import { getReviewOutcome } from '../demeter/submitFormData'

export const getTaskData=(hermes:ReducerState$Type, jwt:string,taskAcceptedInfoId: number)=>{
    return (dispatch:Dispatch) => getHermesTaskApi(jwt,taskAcceptedInfoId.toString())
    .then((res)=>res.json()).then((data)=>{
        const error = (data.error:any|null)
        if (error){
            dispatch({type: actionTypes.HERMES_EDIT_VERIFY_FORM_DATA_ERROR,error: error});
        }else {
            const formData = transformDataToEditFormData(data,hermes)
            dispatch({
                type: actionTypes.HERMES_EDIT_VERIFY_FORM_DATA_SUCCESS, 
                formData: formData,reviewQuestions: data['reviewQuestions'] });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.HERMES_EDIT_VERIFY_FORM_DATA_ERROR, error: err});
    })
}

export const invoiceSubmissionCompleted = () => {
    return { type: actionTypes.HERMES_INV_SUBMITTED_COMPLETED };
}

export const invoiceSubmission = (jwt:any,taskAcceptedInfoId:number,hermesResultset:any,hermes:ReducerState$Type)=>{
    let payload:PostPayloadData={
        taskAcceptedInfoId:taskAcceptedInfoId
    };

    if (hermesResultset.isInvalidDoc){
        payload.isInvalidDoc=true;
    }else {
        payload.vendorName=hermesResultset.vendorName;
        payload.invNo=hermesResultset.invNo;
        payload.invDate=hermesResultset.invDate;
        payload.invTotal=hermesResultset.invTotal;
        payload.isOverrideInvTotal=hermesResultset.isOverrideInvTotal?hermesResultset.isOverrideInvTotal:false;
        payload.isInvalidDoc=hermesResultset.isInvalidDoc?hermesResultset.isInvalidDoc:false;
        payload.poNo=hermesResultset.poNo?hermesResultset.poNo:'';
        payload.subTotal=hermesResultset.subTotal;
        payload.tax=hermesResultset.tax;
        payload.additional=hermesResultset.additional;
        payload.isOverrideVendorName=hermesResultset.isOverrideVendorName?hermesResultset.isOverrideVendorName:false;
        payload.isOverrideAdditionalNotfound=hermesResultset.isOverrideAdditionalNotfound?hermesResultset.isOverrideAdditionalNotfound:false
        payload.isOverrideTaxNotfound=hermesResultset.isOverrideTaxNotfound?hermesResultset.isOverrideTaxNotfound:false
    }

    if (hermes.reviewQuestions && hermes.reviewQuestions.length > 0){
        payload.reviewOutcome=getReviewOutcome(hermesResultset,hermes.reviewQuestions)
    }
    
    return (dispatch:Dispatch) => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data['error']){
            dispatch({type: actionTypes.HERMES_INV_SUBMIT_ERROR, error: data.error});
        }else {
            dispatch({type: actionTypes.HERMES_INV_SUBMIT_SUCCESS});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.HERMES_INV_SUBMIT_ERROR, error: err});
    })
}

export const updateFormError=(error:any|null)=>{
    return { type: actionTypes.HERMES_UPDATE_FORM_ERROR, formError: error }
}

export const populateVendorsList=(jwt:any)=>{
    return (dispatch:Dispatch) => getHermesVendorsApi(jwt).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.REFRESH_HERMES_VENDORS_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.REFRESH_HERMES_VENDORS_SUCCESS, hermesVendors: data.hermesVendors });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_HERMES_VENDORS_ERROR, error: err});
    })
}


// WEBPACK FOOTER //
// ./src/redux/hermes/actions.js